import React from 'react';
import PropTypes from 'prop-types';
import AltContainer from 'alt-container';
import CoachingReviewTypeStore from 'stores/coaching/CoachingReviewTypeStore';
import ReviewTypeEditPage from 'components/pure/admin/ReviewTypeEditPage';
import CoachingReviewTypeActions from 'actions/coaching/CoachingReviewTypeActions';
import {unsavedMessage} from 'utils/const';
import {List} from 'immutable';
import CoachingReviewType from 'records/CoachingReviewType';

const defaultType = new CoachingReviewType({
  name: '',
  includesCalls: true,
  questions: List(),
  callWeighting: 100,
});

export default class ReviewTypeEditPageContainer extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {noChanges: true};

    this.onChange = this.onChange.bind(this);
    this.getType = this.getType.bind(this);
    this.meetingCategories = this.meetingCategories.bind(this);
    this.otherTypesWithCallsExist = this.otherTypesWithCallsExist.bind(this);
    this.routerWillLeave = this.routerWillLeave.bind(this);
  }

  routerWillLeave(location) {
    // Don't show warning on submit
    if (location.state && location.state.submit) {
      return null;
    }

    // If nothing has changed don't show the warning
    if (this.state.noChanges) {
      return null;
    }

    return unsavedMessage;
  }

  componentDidMount() {
    const id = this.props.routeParams.typeId;
    if (id) {
      CoachingReviewTypeActions.fetchReviewTypeById(id);
    }
    this.context.router.setRouteLeaveHook(this.props.route, this.routerWillLeave);

    CoachingReviewTypeActions.fetchMeetingCategories();
  }

  onChange(noChanges) {
    this.setState({noChanges});
  }

  getTypeId() {
    return parseInt(this.props.routeParams.typeId, 10);
  }

  getType() {
    const id = this.getTypeId();
    return CoachingReviewTypeStore.getState().types.get(id, defaultType);
  }

  meetingCategories() {
    return CoachingReviewTypeStore.getState().meetingCategories;
  }

  otherTypesWithCallsExist() {
    const id = this.getTypeId();
    const {types} = CoachingReviewTypeStore.getState();
    return types.filter(type => type.id !== id && type.includesCalls).size > 0;
  }

  render() {
    const id = this.getTypeId();
    return (
      <AltContainer
        stores={[CoachingReviewTypeStore]}
        inject={{
          type: this.getType,
          meetingCategories: this.meetingCategories,
          otherTypesWithCallsExist: this.otherTypesWithCallsExist,
        }}>
        <ReviewTypeEditPage {...this.props} onChange={this.onChange} newType={!id} />
      </AltContainer>
    );
  }
}

ReviewTypeEditPageContainer.contextTypes = {
  router: PropTypes.object,
};
